export default __webpack_public_path__ + "static/media/myPic.2f257013.jpg";